<div class="info-secundaria">
    <p class="nome-fantasia">{{ item.NomeFantasia }}</p>
    <p class="endereco">{{ item.Endereco }}, {{ item.Numero }}</p>
    <p class="localidade">{{ item.Bairro }} - {{ item.Cidade }} / {{ item.UF }}</p>
    <p class="cep">{{ formatarCEP(item.Cep) }}</p>
</div>